import React, { useState, useEffect } from 'react';
import './Youtube.css';

const YouTubeThumbnails = ({ onVideoCountUpdate }) => {
    const [videos, setVideos] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [videoCount, setVideoCount] = useState(0);

    // 👇 यहाँ आपकी ACTUAL Channel ID डाली है
    const CHANNEL_ID = "UCxYJ1sBCI22V-ynJ63XhHYg";

    useEffect(() => {
        fetchVideos();
    }, []);

    const fetchVideos = () => {
        // CORS proxy का use कर रहे हैं ताकि browser restrict न करे
        const proxyUrl = 'https://api.allorigins.win/get?url=';
        const rssUrl = `https://www.youtube.com/feeds/videos.xml?channel_id=${CHANNEL_ID}`;

        setLoading(true);

        fetch(`${proxyUrl}${encodeURIComponent(rssUrl)}`)
            .then(response => {
                if (!response.ok) throw new Error('Network response was not ok');
                return response.json();
            })
            .then(data => {
                try {
                    // XML parse करें
                    const parser = new DOMParser();
                    const xmlDoc = parser.parseFromString(data.contents, "text/xml");
                    const items = xmlDoc.getElementsByTagName("entry");

                    const videoList = [];
                    const maxVideos = 6;

                    for (let i = 0; i < Math.min(maxVideos, items.length); i++) {
                        const item = items[i];

                        // Video ID निकालें
                        const videoIdElement = item.getElementsByTagName("yt:videoId")[0];
                        const videoId = videoIdElement ? videoIdElement.textContent : '';

                        // Title निकालें
                        const titleElement = item.getElementsByTagName("title")[0];
                        const title = titleElement ? titleElement.textContent : 'No Title';

                        // YouTube thumbnail URL (HD quality)
                        const thumbnail = `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;

                        // Published date
                        const publishedElement = item.getElementsByTagName("published")[0];
                        const published = publishedElement ? publishedElement.textContent : '';

                        if (videoId && title) {
                            videoList.push({
                                id: videoId,
                                title: title,
                                thumbnail: thumbnail,
                                link: `https://www.youtube.com/watch?v=${videoId}`,
                                shortTitle: title.length > 60 ? title.substring(0, 60) + "..." : title,
                                published: published
                            });
                        }
                    }

                    if (videoList.length === 0) {
                        throw new Error('No videos found in RSS feed');
                    }

                    // 🎯 VIDEO COUNT UPDATE
                    console.log("📊 YouTube videos fetched:", videoList.length);
                    setVideoCount(videoList.length);

                    // 🎯 PARENT COMPONENT KO COUNT BHEJO
                    if (onVideoCountUpdate) {
                        console.log("📤 Sending video count to parent:", videoList.length);
                        onVideoCountUpdate(videoList.length);
                    }

                    setVideos(videoList);
                    setLoading(false);
                    setError(null);

                } catch (parseError) {
                    console.error("Parse error:", parseError);
                    throw new Error('Failed to parse video data');
                }
            })
            .catch(error => {
                console.error("Fetch error:", error);
                setError(`Failed to load videos: ${error.message}`);
                setLoading(false);
                // Fallback: Show message
                setVideos([]);

                // 🎯 FALLBACK VIDEO COUNT
                const fallbackCount = 51; // Default count
                console.log("⚠️ Using fallback video count:", fallbackCount);
                setVideoCount(fallbackCount);
                if (onVideoCountUpdate) {
                    onVideoCountUpdate(fallbackCount);
                }
            });
    };

    const handleRetry = () => {
        fetchVideos();
    };

    // Format date
    const formatDate = (dateString) => {
        if (!dateString) return '';
        const date = new Date(dateString);
        return date.toLocaleDateString('en-IN', {
            day: 'numeric',
            month: 'short',
            year: 'numeric'
        });
    };

    if (loading) {
        return (
            <div className="loading-container">
                <div className="loader"></div>
                <p>Loading latest videos from BG RealEstate360...</p>
                <div style={{ marginTop: '10px', fontSize: '14px', color: '#666' }}>
                    Fetching video count...
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="error-container">
                <p style={{ color: '#1E6FA8 ', fontSize: '18px' }}>⚠️ {error}</p>
                <button onClick={handleRetry} className="retry-btn">
                    Try Again
                </button>
                <div style={{ marginTop: '20px', fontSize: '14px', color: '#555' }}>
                    <p>Showing {videoCount} videos from our channel</p>
                    <p>
                        Visit: <a
                            href={`https://www.youtube.com/channel/${CHANNEL_ID}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ color: '#1E6FA8 ' }}
                        >
                            BG RealEstate360 YouTube
                        </a>
                    </p>
                </div>
            </div>
        );
    }

    return (
        <div className="youtube-thumbnails-container">
            <div className="section-header">
                <h2>
                    <span style={{ color: '#1E6FA8  ', marginRight: '10px' }}>▶</span>
                    BG RealEstate360 - Latest Property Listing Videos
                    <span style={{
                        marginLeft: '15px',
                        fontSize: '16px',
                        background: '#f0f0f0',
                        padding: '3px 10px',
                        borderRadius: '12px',
                        color: '#333'
                    }}>
                        {videoCount}+ Videos
                    </span>
                </h2>
                <button onClick={handleRetry} className="refresh-btn" title="Refresh videos">
                    🔄 Refresh
                </button>
            </div>

            <div className="videos-grid">
                {videos.map((video) => (
                    <a
                        key={video.id}
                        href={video.link}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="video-card"
                    >
                        <div className="thumbnail-wrapper">
                            <img
                                src={video.thumbnail}
                                alt={video.title}
                                className="video-thumbnail"
                                onError={(e) => {
                                    // Fallback if thumbnail fails to load
                                    e.target.onerror = null;
                                    e.target.src = `https://img.youtube.com/vi/${video.id}/default.jpg`;
                                }}
                            />
                            <div className="play-overlay">
                                <div className="play-button">
                                    <span>▶</span>
                                </div>
                            </div>
                            <div className="youtube-logo">YouTube</div>
                        </div>

                        <div className="video-info">
                            <h3 className="video-title">{video.shortTitle}</h3>
                            {video.published && (
                                <div className="video-date">
                                    📅 {formatDate(video.published)}
                                </div>
                            )}
                            <div className="watch-now">
                                Watch Now →
                            </div>
                        </div>
                    </a>
                ))}
            </div>

            <div className="view-more">
                <a
                    href={`https://www.youtube.com/channel/${CHANNEL_ID}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="channel-link"
                >
                    View All {videoCount}+ Videos on YouTube Channel →
                </a>
            </div>

            <div className="footer-note">
                {/* <p>Videos loaded from YouTube RSS feed • Channel: JSPS Foundation • Total: {videoCount} videos</p> */}
            </div>
        </div>
    );
};

export default YouTubeThumbnails;